var map = {
	"./addval.png": "5014",
	"./arauco.png": "3400",
	"./bon secours mercy health.png": "2397",
	"./clinica los andes.png": "2824",
	"./doctors hospital reinassance.png": "3a89",
	"./flourish research.png": "b3fc",
	"./grupo mandarin house.png": "3e18",
	"./mount sinai.png": "b5e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4c48";